import React from "react";
import PropTypes from "prop-types";
import ReactTable from "components/ReactTable/ReactTable";
import { Row, Col, Card, CardHeader, CardBody, CardTitle, Button } from "reactstrap";
import { Backdrop } from "components";
import { FiLoader } from "react-icons/fi";
import { IoMdRefresh } from "react-icons/io";

const CustomTable = ({
	data = [],
	actions = () => {},
	columns,
	defaultPageSize = 10,
	title = "",
	csvName = "report.csv",
	loading = false,
	marginClass = "mt-5",
	refetch,
}) => {
	const tableData = data.map((item) => ({
		...item,
		actions: actions(item),
	}));

	return (
		<Row className={marginClass}>
			<Col xs={12} md={12}>
				<Card>
					<CardHeader>
						<CardTitle className="mt-2 mb-0 ml-2 h4 font-weight-bold d-flex justify-content-between">
							<span>{title}</span>
							{refetch && <IoMdRefresh onClick={refetch} style={{ cursor: "pointer" }} />}
						</CardTitle>
					</CardHeader>
					<CardBody>
						{tableData && tableData.length ? (
							<ReactTable
								data={tableData}
								filterable
								columns={columns}
								defaultPageSize={defaultPageSize}
								showPaginationTop
								csvName={csvName}
								showPaginationBottom={false}
								className="-striped -highlight primary-pagination"
							/>
						) : (
							<div className="ml-2">No {title?.toLocaleLowerCase()} yet</div>
						)}
						<Backdrop open={loading} fitToParent={true}>
							<div className="text-center position-absolute">
								<FiLoader size={40} className="animate-spin" />
							</div>
						</Backdrop>
					</CardBody>
				</Card>
			</Col>
		</Row>
	);
};

CustomTable.propTypes = {
	data: PropTypes.array,
	actions: PropTypes.func,
	columns: PropTypes.array,
	defaultPageSize: PropTypes.number,
	title: PropTypes.string,
};

export default CustomTable;
